import { Icon } from '@mui/material';
import React from 'react';
const RupeeIcon = (props) => {
    return ( <Icon style={{fontSize:"16px",lineHeight:"1.1"}}>currency_rupee</Icon> );
}
 
export default RupeeIcon;